<template>
  <div class="my-footer">
    <h2>{{ $t("footer.title") }}</h2>
    <!-- <h3 class="email">
      <a href="mailto:ivanlencina93@gmail.com">ivanlencina93@gmail.com</a>
    </h3> -->
    <h3 class="email">
      {{ $t("footer.description") }}
    </h3>
    <div class="icons">
      <a href="mailto:ivanlencina93@gmail.com">
        <img src="@/assets/email.png" alt="" />
      </a>
      <a
        href="https://www.linkedin.com/in/iv%C3%A1n-lencina-601aaa5b/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="@/assets/li.png" alt="" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyFooter",
  components: {},
};
</script>
<style lang="scss" scoped>
div.my-footer {
  height: 30vh;
  background-color: rgb(11, 14, 17);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  color: #fff;
  font-family: "Raleway";

  h2 {
    font-size: 2.5rem;
  }

  div.icons {
    img {
      height: 2rem;
      margin: 0.6rem;
    }
  }
}
</style>
